import { connect } from 'react-redux';
import PrivateRoute from './PrivateRoute'

const mapStateToProps = (state, props) => {
 
    return {
	authenticated: state.session.authenticated
    }
}

const mapDispatchToProps = (dispatch, state) => {
    return {

    }
}

const PrivateRouteContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PrivateRoute);




export default PrivateRouteContainer;



// WEBPACK FOOTER //
// ./src/utils/PrivateRoute/Container.js